import { IDataPages } from 'common/contracts';

export const pageData: IDataPages[] = [
  {
    id: 'dataCenter',
    route: 'data-center',
    pos: { top: 75, left: 91, unit: '%' },
    label: 'Data Center',
    title: 'Data Center',
    content: [
      'A data center is a facility with large amounts of hardware. The most critical value to protect is the data stored on the hardware. By protecting the hardware, we are protecting your data. It’s important to store your data securely, whether it’s your personal photos or customer files.',
      'We make sure that your data is safe by having complete solutions for the entire building, both indoors and outdoors.'
    ],
    backgroundImage: 'data_center_overview_v2.png',
    parentRoute: 'city-scape',
    productsWithPosition: [{ title: 'Autrosense', pos: { top: 85, left: 7, unit: '%' } }]
  },
  {
    id: 'hospital',
    route: 'hospital',
    pos: { top: 63, left: 58, unit: '%' },
    label: 'Hospital',
    title: 'Hospital',
    content: [
      'A hospital is a large and complex construction to protect – consisting of several buildings spread over a large area. There are also activities going on, that cannot be interrupted in any circumstances, not even if a fire occurs. An event of evacuation is very time consuming due to the number of immobile patients.',
      'We also need to take into consideration that we live in a globalized world. A world where we need systems in place to effectively deal with terror threats – even in hospitals. These systems need to detect and raise the alarm in minimal time.'
    ],
    backgroundImage: 'hospital.png',
    parentRoute: 'city-scape',
    productsWithPosition: []
  },
  {
    id: 'hotel',
    route: 'hotel',
    pos: { top: 37, left: 65, unit: '%' },
    label: 'Hotel',
    title: 'Hotel',
    content: [
      'It should be pleasant and worry-free to stay at a hotel. Few guests think about their fire safety during their stay – that is why it is vital that you do.',
      'Most hotels are high-rise building, and there is a long way down to safety from the top floor. From the spa to the kitchen, stages with pyrotechnic smoke, large atriums, and underground parking – hotels are quite complex.'
    ],
    backgroundImage: 'Overview_V.2.png',
    parentRoute: 'city-scape',
    productsWithPosition: []
  },
  {
    id: 'cruise',
    route: 'cruise',
    pos: { top: 28, left: 42, unit: '%' },
    label: 'Cruise',
    title: 'Cruise',
    content: [
      'It should be pleasant and worry-free to board a cruise. Few guests think about their fire safety onboard – that is why it is vital that you do.',
      'Have you ever thought about the complexity of a cruise ship? From the spa to the kitchen, stages with pyrotechnic smoke, large atriums and there are even machine rooms below sea level. Not to mention – cruise ships spend most of their time miles away from solid ground.',
      'We can help you with passenger safety.'
    ],
    backgroundImage: 'criuse_overview.png',
    parentRoute: 'city-scape',
    productsWithPosition: []
  },
  {
    id: 'lng',
    route: 'lng',
    pos: { top: 36, left: 22, unit: '%' },
    label: 'LNG',
    title: 'LNG',
    content: [
      'Transporting liquified gas can potentially be dangerous! A leak could occur, which could cause a major incident. It is crucial to have both gas and fire detectors that can detect a leak immediately to keep both the crew, vessel and environment safe.',
      'PS: Now that vessels also use LNF for fuel, gas detection is also required for other types of vessels, not only for carriers.',
      'We provide the required safety solutions for cargo, fuel tanks and fuel lines.'
    ],
    backgroundImage: 'LNG.png',
    parentRoute: 'city-scape',
    productsWithPosition: []
  },
  {
    id: 'windFarm',
    route: 'wind-farm',
    pos: { top: 13, left: 18, unit: '%' },
    label: 'Wind farm',
    title: 'Wind farm',
    content: [
      'Wind farms are one of the fastest growing energy sources in the world!',
      'A wind farm is a group of wind turbines, located either on land or offshore, used to produce electricity. Each windmill produces up to 15MWh, a total of 75 GWh per year.',
      'Did you know that one turn of the turbine blade can generate enough power to supply a normal household for two days?',
      'We have the technology and the solutions needed to protect each windmill from fire and destruction to secure power supply.'
    ],
    backgroundImage: 'overview.png',
    parentRoute: 'city-scape',
    productsWithPosition: []
  },
  {
    id: 'e-house',
    route: 'e-house',
    pos: { top: 28, left: 15, unit: '%' },
    label: 'E-House',
    title: 'E-House',
    content: [
      'eHouse is the heart in every industrial production plant. This is where all medium voltage and low voltage switchgear, critical power equipment and automation cabinets are located, for power distribution to all production processes. Often with very high energy.',
      'The main goal is to minimize any operational interruptions and to protect people and property effectively. Fire safety is therefore a long-term investment that must be thoroughly planned to ensure the business continuity for the plant.',
      'We have complete solutions for the entire building, both indoors and outdoors to keep your data safe.'
    ],
    backgroundImage: 'E-House Overview_V.2.png',
    parentRoute: 'city-scape',
    productsWithPosition: []
  },
  {
    id: 'dataHall',
    route: 'data-hall',
    pos: { top: 40, left: 48, unit: '%' },
    label: 'Data Hall',
    title: 'Data Hall',
    content: [
      'A data hall is a hall with large amounts of servers which can vary in size and design. Servers generate a considerable amount of heat and require a high airflow to remove excess heat. Even small amounts of smoke can lead to damage on the highly sensitive equipment. To avoid any down time, a reliable early detection is crucial.',
      'High airflow will often lead to challenges in detecting smoke using standard detectors. We use AutroSense Cascade High Sensitive Aspirating Smoke Detection. With our solution it can detect smoke at an early stage – even small amounts of smoke.',
      'With our experience and expertise, we will find the best solution for your data hall.'
    ],
    backgroundImage: 'data_hall_v7.jpg',
    parentRoute: 'data-center',
    productsWithPosition: []
  },
  {
    id: 'electricalSwitchingRoom',
    route: 'electrical-switching-room',
    pos: { top: 21, left: 61, unit: '%' },
    label: 'Electrical switching room',
    title: 'Electrical switching room',
    content: [
      'All data centers need a stable and reliable source of power. An electrical switching room has a density of cables, switches and electrical equipment that could heat up and produce smoke. To avoid down time and maintain connection to the data center, early smoke detection is crucial.',
      'An early detection will give the operator time to act before any serious damage. We use AutroSense Cascade High Sensitive Aspirating Smoke Detection. With our solution it can detect smoke at an early stage – even small amounts of smoke. For even more sensitive detection, the aspiration system can be included in the cabinets as well.'
    ],
    backgroundImage: 'electrical-switching-room-v3.jpg',
    parentRoute: 'data-center',
    productsWithPosition: []
  },
  {
    id: 'emergencyPowerSupplyRoom',
    route: 'emergency-power-supply-room',
    pos: { top: 29, left: 75, unit: '%' },
    label: 'Emergency power supply room',
    title: 'Emergency power supply room',
    content: [
      'To maintain uptime for the data center in case of a blackout, the emergency power supply room is crucial. A room full of continuously power supplies usually includes batteries – and batteries could develop explosive gases.',
      'An EX certifies AutroGuard Point Detector provides early and reliable smoke detection without the danger of igniting any explosive gases.'
    ],
    backgroundImage: 'emergency-power-supply-rooms-v4.jpg',
    parentRoute: 'data-center',
    productsWithPosition: []
  },
  {
    id: 'transformer-chiller-generator',
    route: 'transformer-chiller-generator',
    pos: { top: 45, left: 75, unit: '%' },
    label: 'Transformer/Chiller/Generator',
    title: 'Transformer/Chiller/Generator',
    content: [
      'The transformer and generator room is a high-risk area. Due to the presence of flammables and electrical equipment, the possibility of high energy fires carries a risk for the entire site.',
      'To protect this area, an AutroGuard Multicriteria Detector will detect heat and smoke – while an AutroFlame Dual IR will detest flaming fires at an early stage. We also provide outdoor solutions.'
    ],
    backgroundImage: 'transformers_chillers_generators_v3.jpg',
    parentRoute: 'data-center',
    productsWithPosition: []
  },
  {
    id: 'technicalControlRoom',
    route: 'technical-control-room',
    pos: { top: 8, left: 60, unit: '%' },
    label: 'Technical control room',
    title: 'Technical control room',
    content: [
      'The technical control room needs to constantly maintain an overview of the data center.',
      'Our system will ease the job for the operator, using the graphical presentation with AutroMaster. The operator can access the system remotely, which prevents unnecessary down time and improves the risk management of the building.'
    ],
    backgroundImage: 'control-rooms-v4.jpg',
    parentRoute: 'data-center',
    productsWithPosition: []
  },
  {
    id: 'office',
    route: 'office',
    pos: { top: 55, left: 30, unit: '%' },
    label: 'Office',
    title: 'Office',
    content: [
      'The office needs 24-hour monitoring. Should a fire occur during the day, you need to fast and effective evacuate, and outside of office-hours, you would need an automatic signaling to the fire brigade. Parallelly, we want to keep disruption of unwanted alarms to a minimum.',
      'The AutroGuard ensures early detection of real incidents – making unwanted alarms history. The minimalistic design can include local sounder and visual alarms that blends nicely into any environment.'
    ],
    backgroundImage: 'office_v5.jpg',
    parentRoute: 'data-center',
    productsWithPosition: []
  },
  {
    id: 'kitchen',
    route: 'kitchen',
    pos: { top: 75, left: 25, unit: '%' },
    label: 'Kitchen',
    title: 'Kitchen',
    content: [
      'The kitchen, with its bursts of steam, heat, and cooking fumes, is a challenging environment.',
      'Though not challenging enough for us. We can easily distinguish between real smoke and nuisance alarm sources with the DYFI3D algorithms and the brand-new patented detection chamber in the AutroGuard.',
      'The minimalistic design can include local sounder and visual alarms that blends nicely into any environment.'
    ],
    backgroundImage: 'Kitchen_V.4.png',
    parentRoute: 'data-center',
    productsWithPosition: []
  },
  {
    id: 'façade',
    route: 'façade',
    pos: { top: 34, left: 21, unit: '%' },
    label: 'Façade',
    title: 'Façade',
    content: [
      'Fires that start indoors is one thing – but what about the fires that starts outdoors?',
      'Fires that started outdoors will usually have developed into a dangerous state, before being detected by normal fire detection systems.',
      'Our façade detection system will detect outdoor fires in seconds and protect your valuables.'
    ],
    backgroundImage: 'Outdoor scene.png',
    parentRoute: 'data-center',
    productsWithPosition: []
  },
  {
    id: 'surgery',
    route: 'surgery',
    pos: { top: 73, left: 37, unit: '%' },
    label: 'Surgery',
    title: 'Surgery',
    content: [
      'A surgery room needs 24-hour monitoring, with or without people in it. This is a room with lots of electric equipment and people who needs assistance in the event of an evacuation. Early detection and notifications are therefore vital.',
      'The AutroGuard ensures early detection of real incidents – making unwanted alarms history. To ensure the room is sterile, our detector can be disinfected. The minimalistic design can include local sounder and visual alarms that blends nicely into any environment.'
    ],
    backgroundImage: 'surgery-v5.png',
    parentRoute: 'hospital',
    productsWithPosition: []
  },
  {
    id: 'nursesStation',
    route: 'nurses-station',
    pos: { top: 65, left: 59, unit: '%' },
    label: 'Nurse’s station',
    title: 'Nurse’s station',
    content: [
      'A nurse’s station needs 24-hour monitoring, with or without people in the area. This area has lots of electric equipment and personnel that needs to evacuate in the event of an evacuation. The information panel will provide fast and accurate information, simultaneously keeping unwanted alarms to a minimum. Early smoke detection and notifications are therefore vital.',
      'The AutroGuard ensures early detection of real incidents – making unwanted alarms history.',
      'The minimalistic design can include local sounder and visual alarms that blends nicely into any environment.'
    ],
    backgroundImage: 'nurses-station-v5.png',
    parentRoute: 'hospital',
    productsWithPosition: []
  },
  {
    id: 'patientRoom',
    route: 'patient-room',
    pos: { top: 55, left: 33, unit: '%' },
    label: 'Patient Room',
    title: 'Patient Room',
    content: [
      'A patient room needs 24-hour monitoring, with or without people in it. This is a room with lots of electric equipment and people who needs assistance in the event of an evacuation. Early detection and notifications are therefore vital.',
      'The AutroGuard ensures early detection of real incidents – making unwanted alarms history.',
      'The minimalistic design can include local sounder and visual alarms that blends nicely into any environment.'
    ],
    backgroundImage: 'patient-room-v5.png',
    parentRoute: 'hospital',
    productsWithPosition: []
  },
  {
    id: 'lab',
    route: 'lab',
    pos: { top: 41, left: 27, unit: '%' },
    label: 'LAB',
    title: 'LAB',
    content: [
      'Research laboratories varies greatly and may contain gases in different forms, from storing gas cylinders and having piping with potential leakage points. Not to mention activities could include mixing chemicals from where other gas compounds may arise. With minimal to no maintenance required, the HC200 gas detector is ideal to detect hydrocarbon-based gases and mixtures.',
      'PS: Toxic gases are also likely to be present. To make sure the working environment is healthy for the people working there, it is likely that you want to monitor the oxygen level in the laboratory. For these types of gases – contact your sales representative for an overview of what we can offer.'
    ],
    backgroundImage: 'lab-v4.png',
    parentRoute: 'hospital',
    productsWithPosition: []
  },
  {
    id: 'foyer',
    route: 'foyer',
    pos: { top: 33, left: 48, unit: '%' },
    label: 'Foyer',
    title: 'Foyer',
    content: [
      'The reception area is the first room you enter. Usually, it is a large area with high ceilings. For wide and open spaces like that, we recommend our beam detector FireRay 3000. With high ceilings it will take longer for smoke to reach normal point detectors. Beam detector can be placed in different heights (for vast areas), to get quicker and more reliable smoke detection.'
    ],
    backgroundImage: 'foyer-v4.png',
    parentRoute: 'hospital',
    productsWithPosition: []
  },
  {
    id: 'technicalControlRoom',
    route: 'technical-control-room',
    pos: { top: 28, left: 20, unit: '%' },
    label: 'Technical control room',
    title: 'Technical control room',
    content: [
      'The technical control room needs to constantly maintain an overview of the data center.',
      'Our system will ease the job for the operator, using the graphical presentation with AutroMaster. The operator can access the system remotely, which prevents unnecessary down time and improves the risk management of the building.'
    ],
    backgroundImage: 'control-rooms-v4.jpg',
    parentRoute: 'hospital',
    productsWithPosition: []
  },
  {
    id: 'façade',
    route: 'façade',
    pos: { top: 11, left: 35, unit: '%' },
    label: 'Façade',
    title: 'Façade',
    content: [
      'Fires that start indoors is one thing – but what about the fires that starts outdoors?',
      'Fires that started outdoors will usually have developed into a dangerous state, before being detected by normal fire detection systems.',
      'Our façade detection system will detect outdoor fires in seconds and protect your valuables.'
    ],
    backgroundImage: 'Outdoor scene.png',
    parentRoute: 'hospital',
    productsWithPosition: []
  },
  {
    id: 'bedroom',
    route: 'bedroom',
    pos: { top: 48, left: 80, unit: '%' },
    label: 'Bedroom',
    title: 'Bedroom',
    content: [
      'The bedroom needs 24-hour monitoring, with or without people in it. With the increasing use of electronic devices in all rooms of a building, portable chargers and equipment charging overnight – early detection and notification is vital.',
      'The AutroGuard ensures early detection of real incidents – making unwanted alarms history.',
      'The minimalistic design can include local sounder and visual alarms that blends nicely into any environment.'
    ],
    backgroundImage: 'Bedroom_V.3.png',
    parentRoute: 'hotel',
    productsWithPosition: []
  },
  {
    id: 'foyer',
    route: 'foyer',
    pos: { top: 33, left: 48, unit: '%' },
    label: 'Foyer',
    title: 'Foyer',
    content: [
      'The reception area is the first room you enter. Usually, it is a large area with high ceilings. For wide and open spaces like that, we recommend our beam detector FireRay 3000. With high ceilings it will take longer for smoke to reach normal point detectors. Beam detector can be placed in different heights (for vast areas), to get quicker and more reliable smoke detection.'
    ],
    backgroundImage: 'foyer-v4.png',
    parentRoute: 'hotel',
    productsWithPosition: []
  },
  {
    id: 'kitchen',
    route: 'kitchen',
    pos: { top: 30, left: 17, unit: '%' },
    label: 'Kitchen',
    title: 'Kitchen',
    content: [
      'The kitchen, with its bursts of steam, heat, and cooking fumes, is a challenging environment.',
      'Though not challenging enough for us. We can easily distinguish between real smoke and nuisance alarm sources with the DYFI3D algorithms and the brand-new patented detection chamber in the AutroGuard.',
      'The minimalistic design can include local sounder and visual alarms that blends nicely into any environment.'
    ],
    backgroundImage: 'Kitchen_V.4.png',
    parentRoute: 'hotel',
    productsWithPosition: []
  },
  {
    id: 'conferenceHall',
    route: 'conference-hall',
    pos: { top: 70, left: 33, unit: '%' },
    label: 'Conference hall',
    title: 'Conference hall',
    content: [
      'A conference hall is a large room, used for meetings, conferences and other events – often with a stage in front. With the possibilities of individual settings for each point detector, as well as adapting to the ambient environment for both point and aspiration detectors, they can handle all challenges with changes in occupancy, ventilation, and temperature.',
      'With the added functionality of the CO detector, you can use stage smoke and still have a fully functional fire detection system.'
    ],
    backgroundImage: 'Large conference room_V.3.png',
    parentRoute: 'hotel',
    productsWithPosition: []
  },
  {
    id: 'technicalControlRoom',
    route: 'technical-control-room',
    pos: { top: 40, left: 25, unit: '%' },
    label: 'Technical control room',
    title: 'Technical control room',
    content: [
      'The technical control room needs to constantly maintain an overview of the data center.',
      'Our system will ease the job for the operator, using the graphical presentation with AutroMaster. The operator can access the system remotely, which prevents unnecessary down time and improves the risk management of the building.'
    ],
    backgroundImage: 'control-rooms-v4.jpg',
    parentRoute: 'hotel',
    productsWithPosition: []
  },
  {
    id: 'façade',
    route: 'façade',
    pos: { top: 14, left: 35, unit: '%' },
    label: 'Façade',
    title: 'Façade',
    content: [
      'Fires that start indoors is one thing – but what about the fires that starts outdoors?',
      'Fires that started outdoors will usually have developed into a dangerous state, before being detected by normal fire detection systems.',
      'Our façade detection system will detect outdoor fires in seconds and protect your valuables.'
    ],
    backgroundImage: 'Outdoor scene.png',
    parentRoute: 'hotel',
    productsWithPosition: []
  },
  {
    id: 'technicalControlRoom',
    route: 'technical-control-room',
    pos: { top: 28, left: 78, unit: '%' },
    label: 'Technical control room',
    title: 'Technical control room',
    content: [
      'The technical control room needs to constantly maintain an overview of the vessel.',
      'Our system will give an overview over the vessel for the, providing exact location of the early detected fire and warnings. AutroMaster ISEMS prevents unnecessary down time and improves the risk management of the vessel.'
    ],
    backgroundImage: 'control-rooms-v4.jpg',
    parentRoute: 'cruise',
    productsWithPosition: []
  },
  {
    id: 'engineRoom',
    route: 'engine-room',
    pos: { top: 53, left: 88, unit: '%' },
    label: 'Engine Room',
    title: 'Engine Room',
    content: [
      'High voltage rooms and engine rooms contain a lot of energy and is a rough environment with flammables, such as oil and diesel.',
      'This makes the high voltage room a high-risk area that requires a flame detector and AutroGuard point detector, in addition to local water mist protection.',
      'The best solution in our experience is to combine the AutroFlame and AutroGuard detectors in these areas.'
    ],
    backgroundImage: 'Engine Room_V.4.png',
    parentRoute: 'cruise',
    productsWithPosition: []
  },
  {
    id: 'bedroom',
    route: 'bedroom',
    pos: { top: 43, left: 78, unit: '%' },
    label: 'Bedroom',
    title: 'Bedroom',
    content: [
      'A cabin needs 24-hour monitoring, with or without people in it. With the increasing use of electronic devices in all rooms of a building, portable chargers and equipment charging overnight – early detection and notification is vital.',
      'The AutroGuard ensures early detection of real incidents – making unwanted alarms history.',
      'The minimalistic design can include local sounder and visual alarms that blends nicely into any environment.'
    ],
    backgroundImage: 'Bedroom vessels_V.3.png',
    parentRoute: 'cruise',
    productsWithPosition: []
  },
  {
    id: 'conferenceHall',
    route: 'conference-hall',
    pos: { top: 45, left: 35, unit: '%' },
    label: 'Conference hall',
    title: 'Conference hall',
    content: [
      'A conference hall is a large room, used for meetings, conferences and other events – often with a stage in front. With the possibilities of individual settings for each point detector, as well as adapting to the ambient environment for both point and aspiration detectors, they can handle all challenges with changes in occupancy, ventilation, and temperature.',
      'With the added functionality of the CO detector, you can use stage smoke and still have a fully functional fire detection system.'
    ],
    backgroundImage: 'Large conference room_V.3.png',
    parentRoute: 'cruise',
    productsWithPosition: []
  },
  {
    id: 'engineRoom',
    route: 'engine-room',
    pos: { top: 64, left: 21, unit: '%' },
    label: 'Engine Room',
    title: 'Engine Room',
    content: [
      'High voltage rooms and engine rooms contain a lot of energy and is a rough environment with flammables, such as oil and diesel.',
      'This makes the high voltage room a high-risk area that requires a flame detector and AutroGuard point detector, in addition to local water mist protection.',
      'The best solution in our experience is to combine the AutroFlame and AutroGuard detectors in these areas.'
    ],
    backgroundImage: 'Engine room_V.4.png',
    parentRoute: 'lng',
    productsWithPosition: []
  },
  {
    id: 'bedroom',
    route: 'bedroom',
    pos: { top: 51, left: 20, unit: '%' },
    label: 'Bedroom',
    title: 'Bedroom',
    content: [
      'A cabin needs 24-hour monitoring, with or without people in it. With the increasing use of electronic devices in all rooms of a building, portable chargers and equipment charging overnight – early detection and notification is vital.',
      'The AutroGuard ensures early detection of real incidents – making unwanted alarms history.',
      'The minimalistic design can include local sounder and visual alarms that blends nicely into any environment.'
    ],
    backgroundImage: 'Bedroom vessels_V.3.png',
    parentRoute: 'lng',
    productsWithPosition: []
  },
  {
    id: 'hull',
    route: 'hull',
    pos: { top: 64, left: 55, unit: '%' },
    label: 'Hull',
    title: 'Hull',
    content: [
      'Double-hull and double-bottom spaces next to tanks shall be provided with a fixed hydrocarbon gas detection system.',
      'Our gas detection system provides a good, early, and reliable detection of flammable gases that could occur.'
    ],
    backgroundImage: 'Hull_V.5.png',
    parentRoute: 'lng',
    productsWithPosition: []
  },
  {
    id: 'reliqueficationPlant',
    route: 'reliquefication-plant',
    pos: { top: 52, left: 54, unit: '%' },
    label: 'Reliquefication plant',
    title: 'Reliquefication plant',
    content: [
      'Extreme operating conditions causes thermal expansion of liquefaction installation. This includes compressor, pump or hydraulic turbine being potential sources of leaks. A refrigeration process turns the gas into a liquid. To obtain maximum volume reduction, the gas liquefied through the relevant refrigeration technology.',
      'Implementation of gas detection systems for detection of natural gas and various refrigerants is crucial for sustaining the processes at liquefaction plants. Out gas detection system provides a good, early, and reliable detection of flammable gases.'
    ],
    backgroundImage: 'Re-liquefaction plant_V.3.png',
    parentRoute: 'lng',
    productsWithPosition: []
  },
  {
    id: 'nacelle',
    route: 'nacelle',
    pos: { top: 57, left: 75, unit: '%' },
    label: 'Nacelle',
    title: 'Nacelle',
    content: [
      'It is in a Nacelle you will find the gear box and the generator that transforms the energy from wind power into electrical power. In this compact compartment, there are very high forces present, both mechanical and electric. We offer the best solution to ensure control of this unmanned high hazard space that provides early warning with no false alarms. AutroGuard Protectors combined with AutroFlame Dual IR flame detectors and AutroSense HighSensitive Smoke Detection (HSSD).'
    ],
    backgroundImage: 'Windfarm nacelle_V.8.png',
    parentRoute: 'wind-farm',
    productsWithPosition: []
  },
  {
    id: 'tower',
    route: 'tower',
    pos: { top: 57, left: 36, unit: '%' },
    label: 'Tower',
    title: 'Tower',
    content: [
      'It is in the Tower you will find the main power cables that run down from the Nacelle. Offshore towers have enclosures/pumps/HVAC-systems in the base of the tower that needs to be monitored and protected. Should a fire occur in this area, it could result in a collapse of the whole windmill. We offer the best solution for this type of application, that provides early warning with no false alarms, with AutroSafe with AutroGuard Protectors.'
    ],
    backgroundImage: 'Windfarm tower_V.3.png',
    parentRoute: 'wind-farm',
    productsWithPosition: []
  },
  {
    id: 'dataHall',
    route: 'data-hall',
    pos: { top: 32, left: 61, unit: '%' },
    label: 'Data Hall',
    title: 'Data Hall',
    content: [
      'A data hall is a hall with large amounts of servers which can vary in size and design. Servers generate a considerable amount of heat and require a high airflow to remove excess heat. Even small amounts of smoke can lead to damage on the highly sensitive equipment. To avoid any down time, a reliable early detection is crucial.',
      'High airflow will often lead to challenges in detecting smoke using standard detectors. We use AutroSense Cascade High Sensitive Aspirating Smoke Detection. With our solution it can detect smoke at an early stage – even small amounts of smoke.',
      'With our experience and expertise, we will find the best solution for your data hall.'
    ],
    backgroundImage: 'data_hall_v7.jpg',
    parentRoute: 'e-house',
    productsWithPosition: []
  },
  {
    id: 'electricalSwitchingRoom',
    route: 'electrical-switching-room',
    pos: { top: 65, left: 51, unit: '%' },
    label: 'Electrical switching room',
    title: 'Electrical switching room',
    content: [
      'All data centers need a stable and reliable source of power. An electrical switching room has a density of cables, switches and electrical equipment that could heat up and produce smoke. To avoid down time and maintain connection to the data center, early smoke detection is crucial.',
      'An early detection will give the operator time to act before any serious damage. We use AutroSense Cascade High Sensitive Aspirating Smoke Detection. With our solution it can detect smoke at an early stage – even small amounts of smoke. For even more sensitive detection, the aspiration system can be included in the cabinets as well.'
    ],
    backgroundImage: 'electrical-switching-room-v3.jpg',
    parentRoute: 'e-house',
    productsWithPosition: []
  },
  {
    id: 'emergencyPowerSupplyRoom',
    route: 'emergency-power-supply-room',
    pos: { top: 48, left: 35, unit: '%' },
    label: 'Emergency power supply room',
    title: 'Emergency power supply room',
    content: [
      'To maintain uptime for the data center in case of a blackout, the emergency power supply room is crucial. A room full of continuously power supplies usually includes batteries – and batteries could develop explosive gases.',
      'An EX certifies AutroGuard Point Detector provides early and reliable smoke detection without the danger of igniting any explosive gases.'
    ],
    backgroundImage: 'emergency-power-supply-rooms-v4.jpg',
    parentRoute: 'e-house',
    productsWithPosition: []
  },
  {
    id: 'transformer-chiller-generator',
    route: 'transformer-chiller-generator',
    pos: { top: 37, left: 27, unit: '%' },
    label: 'Transformer/Chiller/Generator',
    title: 'Transformer/Chiller/Generator',
    content: [
      'The transformer and generator room is a high-risk area. Due to the presence of flammables and electrical equipment, the possibility of high energy fires carries a risk for the entire site.',
      'To protect this area, an AutroGuard Multicriteria Detector will detect heat and smoke – while an AutroFlame Dual IR will detest flaming fires at an early stage. We also provide outdoor solutions.'
    ],
    backgroundImage: 'transformers_chillers_generators_v3.jpg',
    parentRoute: 'e-house',
    productsWithPosition: []
  },
  {
    id: 'façade',
    route: 'façade',
    pos: { top: 84, left: 35, unit: '%' },
    label: 'Façade',
    title: 'Façade',
    content: [
      'Fires that start indoors is one thing – but what about the fires that starts outdoors?',
      'Fires that started outdoors will usually have developed into a dangerous state, before being detected by normal fire detection systems.',
      'Our façade detection system will detect outdoor fires in seconds and protect your valuables.'
    ],
    backgroundImage: 'Outdoor scene.png',
    parentRoute: 'e-house',
    productsWithPosition: []
  }
];
